import { Button } from 'components/buttons/button';
import { StandardInput } from 'components/forms/input';
import gql from 'graphql-tag';
import { useInput } from 'lib/hooks/use-input';
import {
  useGetWrapppingPriceQuery,
  useSetWrappingPriceMutation,
} from 'lib/graphql-generated';
import currency from 'currency.js';
const GET_WRAPPING = gql`
  query GetWrapppingPrice {
    unstructured_data_by_pk(title: "wrapping") {
      title
      data
    }
  }
`;

const SET_WRAPPING = gql`
  mutation SetWrappingPrice($data: jsonb) {
    update_unstructured_data_by_pk(
      pk_columns: { title: "wrapping" }
      _set: { data: $data }
    ) {
      title
      data
    }
  }
`;

export const WrappingSection = () => {
  const price = useInput<number>(0);
  const { data } = useGetWrapppingPriceQuery({
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      if (data) {
        price.init(
          currency(data.unstructured_data_by_pk.data.price, { fromCents: true })
            .value
        );
      }
    },
  });

  const [save, { loading: saving }] = useSetWrappingPriceMutation({
    onCompleted: (data) => {
      if (data) {
        price.init(
          currency(data.update_unstructured_data_by_pk.data.price, {
            fromCents: true,
          }).value
        );
      }
    },
  });

  return (
    <article className='bg-white shadow rounded-md  py-6 px-4 sm:p-6'>
      <header className=''>
        <h2 className='header text-xl text-gray-900'>Wrapping</h2>
        <p className='mt-1 text-sm text-gray-500'>
          Set the price of gift wrapping for web purchases.
        </p>
      </header>
      <form action='' className='mt-6 grid grid-cols-4 gap-6'>
        <StandardInput
          type='number'
          name='price'
          label='Price'
          id='price'
          bind={{ ...price.bind }}
        />
        <section className='col-span-full'>
          <Button
            buttonType='primary'
            disabled={!price.isModified || saving}
            loading={saving}
            onClick={() => {
              save({
                variables: {
                  data: { price: currency(price.value).intValue },
                },
              });
            }}>
            Save
          </Button>
        </section>
      </form>
    </article>
  );
};
